'use client';

import { List } from '@mui/material';
import styled from 'styled-components';

export const StyledSideMenu = styled(List)`
  position: relative;
  height: inherit;

  .MuiListItemButton-root {
    padding: 10px 11px;

    &.Mui-selected {
      background-color: var(--color-off-white);
      border-radius: 4px;

      > .MuiListItemText-root {
        > span {
          color: #2e4cc2 !important ;
          font-size: 1rem;
          font-weight: 500;
        }
      }
    }
  }

  .MuiListItemIcon-root {
    min-width: 20px !important;
  }

  .MuiListItemText-root {
    margin-left: 9px;
  }

  .item-icon {
    width: 20px !important;
    height: 20px !important;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  .info {
    position: absolute;
    left: 0;
    font-size: 12px;
    bottom: 40px;
    color: #7b7c7c;

    > p {
      line-height: 1.5;
    }
  }
`;
